module.exports = __webpack_public_path__ + "media/城市环境声-体育活动.dfb92ce9.wav";